export * from '@primeuix/themes/lara/treetable';
export { default } from '@primeuix/themes/lara/treetable';
